export const formatDate = (dateString) => {
  if (dateString === null || dateString === undefined || dateString === "") {
    return "N/A";
  }

  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return "N/A";
  }

  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";

  hours = hours % 12 || 12;
  hours = hours.toString().padStart(2, "0");

  return `${day} ${month} ${year} ${hours}:${minutes} ${ampm}`;
};
